// extracted by mini-css-extract-plugin
export var separator = "separator-module--separator--02aae";
export var separatorLoose = "separator-module--separatorLoose--a3753";
export var separatorText = "separator-module--separatorText--a1101";
export var separatorBold = "separator-module--separatorBold--c9d39";
export var separatorDark = "separator-module--separatorDark--d288a";
export var separatorCircle = "separator-module--separatorCircle--52f3a";
export var separatorLine = "separator-module--separatorLine--fe0b7";
export var separatorArrow = "separator-module--separatorArrow--57dc5";